import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'react-router-dom';
import { history } from './app/layout/history';
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from "./authConfig";
import { Provider } from 'react-redux';
import { store } from './app/store/configureStore';
import reportWebVitals from './reportWebVitals';
import App from './app/layout/App';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./app/telemetry/telemetryService";

export const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  const accountInformation = event.payload as AuthenticationResult;
  if (event.eventType === EventType.LOGIN_SUCCESS && accountInformation.account) {
    msalInstance.setActiveAccount(accountInformation.account);
  }
});

msalInstance.enableAccountStorageEvents();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Router history={history}>
      <Provider store={store}>
        <AppInsightsContext.Provider value={reactPlugin}>
          <App msalInstance={msalInstance} />
        </AppInsightsContext.Provider>
      </Provider>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
